import { Grid } from "@mui/material";
import React from "react";
import AdCard from "./AdCard";

const CurrentAdsTab = ({
  anchorEl,
  open,
  handleCloseMenu,
  handleOpenMenu,
  allAds,
  handleDeleteAdModalOpen,
  setSelectedAd,
  allDraftAds,
  selectedAd,
  handleViewsModalOpen,
  handlePricesModalOpen,
}) => {
  // console.log("current adssss:", allAds);
  return (
    <Grid container>
      {allAds.length > 0 ? (
        allAds.map((ad, index) => (
          <AdCard
            anchorEl={anchorEl}
            open={open}
            handleCloseMenu={handleCloseMenu}
            handleOpenMenu={handleOpenMenu}
            ad={ad}
            key={index}
            handleDeleteAdModalOpen={handleDeleteAdModalOpen}
            setSelectedAd={setSelectedAd}
            selectedAd={selectedAd}
            allAds={allAds}
            allDraftAds={allDraftAds}
            handleViewsModalOpen={handleViewsModalOpen}
            handlePricesModalOpen={handlePricesModalOpen}
          />
        ))
      ) : (
        <Grid container alignItems={"center"} justifyContent="center">
          <span>No Current Ads available.</span>
        </Grid>
      )}
    </Grid>
  );
};

export default CurrentAdsTab;
